import Empty from "../components/Empty"
import ConnectList from "../layouts/ConnectList"

const ConnectionRequired = () => {
  return (
    <Empty>
      <ConnectList />
    </Empty>
  )
}

export default ConnectionRequired
